// Auto-generated — re-export of app's tinycld.config.ts
export { tinycldConfig } from '../../tinycld.config'
export type { MergedPackageSchema } from '../../tinycld.config'
